define('filter-service',[], function() {

  var app = angular.module('filter.service', ['ngSanitize']);

  app.filter('html', ['$sce', function($sce) {
    return function(html) {
      return $sce.trustAsHtml(html);
    };
  }]);

});

